import { Component, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-success-send-email',
  templateUrl: './dialog-success-send-email.component.html',
  styleUrls: ['./dialog-success-send-email.component.css']
})
export class DialogSuccessSendEmailComponent implements OnInit {

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialog.closeAll();
  }

}
